import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageVariables } from '../constants/app.enum';

export interface Locale {
  language: string;
  data: any;
}

export type LanguageFlag = {
  locale: string;
  name: string;
  flag: string;
};

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private readonly translate = inject(TranslateService);
  private readonly languageIds: string[] = ['en', 'ru'];

  constructor() {
    this.translate.addLangs(['en', 'ru']);
    this.translate.setDefaultLang('en');
    this.translate.use(this.getSelectedLanguage());
  }

  loadTranslations(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach(locale => {
      this.translate.setTranslation(locale.language, locale.data, true);
      this.languageIds.push(locale.language);
    });

    this.translate.addLangs(this.languageIds);
    this.translate.use(this.getSelectedLanguage());
  }

  setLanguage(language: string): void {
    if (language) {
      this.translate.use(this.translate.getDefaultLang());
      this.translate.use(language);
      localStorage.setItem(StorageVariables.LANGUAGE, language);
    }
  }

  getSelectedLanguage(): string {
    const language = localStorage.getItem(StorageVariables.LANGUAGE);
    return language ?? this.translate.getDefaultLang();
  }
}
